import React, { useState } from 'react';
import { isHauptadmin } from '../../lib/globalData';
import dataProvider from '../../lib/dataProvider';
import { useTranslate, useRecordContext, useListContext, Pagination, 
  List, Datagrid, 
  TextField, SelectField, DateField, Button, 
  TextInput }  from 'react-admin';
import CachedIcon from '@mui/icons-material/Cached';
import { Input, CircularProgress } from '@mui/material';
import get from 'lodash/get';

const actionChoices = [
  { id: 'A', name: 'bw.rep.history.created'},
  { id: 'E', name: 'bw.rep.history.edited'},
  { id: 'D', name: 'bw.rep.history.deleted'},
  { id: 'S', name: 'bw.rep.history.canceled'},
  { id: 'H', name: 'bw.rep.history.hidden'},
]

const InfoLabel = () => {
  const tr = useTranslate();
  return (
    <div>{tr('bw.rep.guesthistory.infolabel')}</div>
  )
}

const listFilter = [
  <TextInput source="guest_no" alwaysOn />,
  <InfoLabel source="info" alwaysOn />
];

const TimezoneDateField = (props) => {
  const record = useRecordContext();
  if(!record?.htz)return (<div>Time zone not set</div>)
  return (
    <DateField {...props} source="datum" label="Hostel time" showTime locales="de-CH" options={{ timeZone: record?.htz, timeZoneName:'shortOffset' }} />
  )
}

const InfoField = () => {
  const record = useRecordContext();
  const tr = useTranslate();
  if(!record)return
  return (
    <div>
      <DiffField source="name" />
      <DiffField source="vorname" />
      <DiffField source="land" />
      <DiffField source="passland" />
      <DiffField source="email" />
      <DiffField source="bemerkungen" />
      <DiffField source="station" />
      <div>
        <span>{tr('bw.rep.guesthistory.bem')}: </span>
        <span>{get(record, 'bem', '')}</span>
      </div>
    </div>
  )
}

const HistDetails = () => {
  const record = useRecordContext();
  if(!record)return
  if(!isHauptadmin()) return
  const { name, vorname, land, passland, email, bemerkungen, station, ...restfields } = record.loginfo 
  var objects = []
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, auto)', gap: 2 }}>
        {Object.entries(restfields).map(([key, value]) => {
          if(typeof value === 'string') return (<DiffField source={key} titleRef={false} />)
          if(typeof value === 'object') return objects = Object.entries(value).map(([skey, val]) => <DiffField source={key+'.'+skey} titleRef={false} />)
          return <></>
        })}
        <div>tab: {record.tab}</div>
      </div>
      <div>{objects}</div>
    </>
  )
}
  
const DiffField = ({source, titleRef=true}) => {
  const tr = useTranslate();
  const record = useRecordContext();
  if(!record)return
  const value = get(record, 'loginfo.'+source, '');
  const is_diff = get(record, 'li_diff.'+source, false);
  const style = is_diff?{fontWeight: 'bold'}:{}
  return (
    <div style={style}>
      { titleRef===true && <span>{tr('bw.rep.guesthistory.'+source)}: </span> }
      { titleRef===false && <span>{source}: </span> }
      <span>{value}</span>
    </div>
  )
}

const CustomPagination = () => {
  const { page, perPage, setPage, total } = useListContext();
  const totalPages = Math.ceil(total / perPage);

  const handlePageChange = (event) => {
    const pageNumber = parseInt(event.target.value, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
      <Pagination page={page} perPage={perPage} setPage={setPage} total={total} rowsPerPageOptions={[5,10,25,50,100,500]} />
      <Input type="number" value={page} onChange={handlePageChange} style={{ width: 50, marginLeft: 10 }} />
    </div>
  );
};

const CustomActions = () => {
  const { filterValues, refetch } = useListContext();
  const [cnt, setCnt] = useState(0)
  const [loading, setLoading] = useState(false);

  const rebuildIndex = () => {
    setLoading(true)
    dataProvider.update('repHistory/rebuild', {id: filterValues?.guest_no, data: { guest: true} })
    .then(res  => {
      setCnt(cnt+1)
      setLoading(false)
      refetch()
    })
  }
  
  return (
    <div style={{ display: 'flex' }}>
      { isHauptadmin() && <Button onClick={() => rebuildIndex()} style={{ minWidth: '15em' }} label="bw.rep.history.rebuild">
        {loading===false?<CachedIcon />:<CircularProgress size={12}/>}
      </Button>}    
    </div>
  )
}

const ListForm = (props) => {
  return (
    <List actions={<CustomActions />} exporter={false} filters={listFilter} sort={{ field: 'datum', order: 'DESC' }} 
      pagination={<CustomPagination />} perPage={50} empty={false} 
    >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} expand={isHauptadmin()?<HistDetails />:false} 
      rowSx={() => ({ verticalAlign: 'top', '& .MuiTableCell-root:nth-of-type(n+2)': { pt: '.5em'} })} >
        <DateField source="datum" showTime locales="de-CH" options={{ timeZoneName:'shortOffset' }} />
        <TimezoneDateField source="datum" label="resources.repGuesthistory.fields.hosteltime" />
        <SelectField source="action" choices={actionChoices} />
        <TextField source="portal_user" />
        <InfoField label="info" />
      {isHauptadmin() &&
        <TextField source="id" textAlign="right" />
      }
      </Datagrid>
    </List>
  )
}

const RepGuesthistory = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} />
  )
}
export default RepGuesthistory